import "./confirm-dialog-style.scss";

//通用確認 dialog
//
//  刻意做成受控元件（open 由外部傳入）：顯示與否是呼叫端的狀態，
//  dialog 自己管會讓「同時只顯示一個」這種需求無法實作。
//
//  props:
//    open        是否顯示
//    title       標題
//    message     內文
//    confirmTxt  確認鈕文字
//    cancelTxt   取消鈕文字；不傳則不顯示取消鈕（純告知型 dialog）
//    onSuccess   按下確認
//    onClose     按下取消或點遮罩
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmTxt = "確認",
  cancelTxt,
  onSuccess,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="dialog-mask" onClick={onClose}>
      {/* 擋掉冒泡，否則點內容區也會關掉 dialog */}
      <div className="dialog-box" onClick={(e) => e.stopPropagation()}>
        {title && <h3 className="dialog-title">{title}</h3>}
        {message && <p className="dialog-message">{message}</p>}

        <div className="dialog-actions">
          {cancelTxt && (
            <button type="button" className="dialog-btn" onClick={onClose}>
              {cancelTxt}
            </button>
          )}
          <button
            type="button"
            className="dialog-btn dialog-btn-primary"
            onClick={onSuccess}
          >
            {confirmTxt}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
